export default "__VITE_ASSET__C6RR_$Y5__"